class ConfigService {
  baseUrl = "";
  client_id = "";
  client_secret = "";
  redirect_domain = "";
  captcha_site_key = "";
  coconut_direct_url = "";
  coconut_accountant_url = "";
  coconut_direct_dev_url = "";
  coconut_accountant_dev_url = "";

  constructor() {
    this.init();
  }

  init() {
    this.setBaseUrl();
    this.setClientInfo();
    this.setCaptchaSiteKey();
    this.setCoconutRedirectUrl();
  }

  setBaseUrl() {
    this.baseUrl = process.env.REACT_APP_BASE_URL;
    this.redirect_domain = process.env.REACT_APP_REDIRECT_DOMAIN;
  }

  setCaptchaSiteKey() {
    this.captcha_site_key = process.env.REACT_APP_CAPTCHA_SITE_SECRET;
  }

  getCaptchaUrl() {
    return this.captcha_domain;
  }

  getCaptchaSiteKey() {
    return this.captcha_site_key;
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  getRedirectUrl() {
    return this.redirect_domain;
  }

  setClientInfo() {
    if (process.env.REACT_APP_CLIENT_ID) {
      this.client_id = process.env.REACT_APP_CLIENT_ID;
    }
    if (process.env.REACT_APP_CLIENT_SECRET) {
      this.client_secret = process.env.REACT_APP_CLIENT_SECRET;
    }
  }

  getClientInfo() {
    return {
      client_id: this.client_id,
      client_secret: this.client_secret,
    };
  }

  setCoconutRedirectUrl() {
    this.coconut_direct_url = process.env.REACT_APP_COCONUT_DIRECT_URL;
    this.coconut_accountant_url = process.env.REACT_APP_COCONUT_ACCOUNTANT_URL;
    this.coconut_direct_dev_url = process.env.REACT_APP_COCONUT_DIRECT_DEV_URL;
    this.coconut_accountant_dev_url =
      process.env.REACT_APP_COCONUT_ACCOUNTANT_DEV_URL;
  }

  getCoconutDirectUrl(domain) {
    return domain === "dev"
      ? this.coconut_direct_dev_url
      : this.coconut_direct_url;
  }

  getCoconutAccountantUrl(domain) {
    return domain === "dev"
      ? this.coconut_accountant_dev_url
      : this.coconut_accountant_url;
  }
}

export const Config = new ConfigService();
